import axios from "axios";

const DEDUP_WINDOW_MS = 3000;
const recentRequests = new Map();

function shouldSendRequest(url, payload) {
  const key = `${url}:${JSON.stringify(payload)}`;
  const now = Date.now();
  const lastSentAt = recentRequests.get(key);

  if (lastSentAt && now - lastSentAt < DEDUP_WINDOW_MS) {
    return false;
  }

  recentRequests.set(key, now);
  return true;
}

function sendJsonRequest(url, payload) {
  if (!shouldSendRequest(url, payload)) {
    return;
  }

  fetch(url, {
    method: "POST",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

async function getCampaign({ siteId, campaignId }) {
  const requestOptions = {
    method: "get",
    headers: { "Content-Type": "application/json" },
    params: {
      siteId,
      campaignId,
    },
  };
  try {
    const requestUrl = `${process.env.VUE_APP_API_URL}/player-get-campaign`
    let res = await axios(
      requestUrl,
      requestOptions
    );


    return res.data
  } catch (err) {
    throw err.response.data;
  }
}


function sendError(errorLog) {
  sendJsonRequest(`${process.env.VUE_APP_API_URL}/player-logs`, errorLog);
}

function sendEvent(dataToSend) {
  sendJsonRequest(`${process.env.VUE_APP_API_URL}/track-event`, dataToSend);
}

async function checkout(data) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data,
  };

  try {
    const res = await axios(
      `${process.env.VUE_APP_API_URL}/checkout`,
      requestOptions
    );
    return res.data;
  } catch (err) {
    window.top.location.href = document.referrer + "/cart";
    throw err.response.data;
  }
}


export default {
  getCampaign,
  sendError,
  sendEvent,
  checkout
};


